module.exports = __webpack_public_path__ + "static/img/last.e0cfa3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/last.png
// module id = AEII
// module chunks = 0